import { gql } from '@apollo/client'

export const PUBLIC_CERTIFICATE_DETAILS_QUERY = gql`
    query PublicCertificateDetails($_id: ID!) {
        publicCertificate(_id: $_id) {
            _id
            name
            createdAt
            quizStartedAt
            numOfQuestions
            numOfQuestionsAnswered
            timeLimitMs
            state
            user {
                _id
                firstname
                name
                email
            }
            certificateConfiguration {
                _id
                name
                description
            }
            currentQuestion
        }
    }
`

export const PUBLIC_CERTIFICATE_STATS_QUERY = gql`
    query PublicCertificateStats($_id: ID!) {
        publicCertificate(_id: $_id) {
            _id
            name
            createdAt
            quizStartedAt
            quizFinishedAt
            numOfQuestions
            requiredPassingThresholdPercentage
            timeLimitMs
            receivedPointsPercentage
            state
            user {
                _id
                firstname
                name
                email
            }
            certificateConfiguration {
                _id
                name
                description
            }
            questions
        }
    }
`

export const PUBLIC_CERTIFICATE_START_MUTATION = gql`
    mutation PublicCertificateStartMutation($_id: ID!) {
        startPublicCertification(_id: $_id) {
            _id
            quizStartedAt
            state
            numOfQuestionsAnswered
            currentQuestion
        }
    }
`

export const PUBLIC_CERTIFICATE_ANSWER_QUESTION_MUTATION = gql`
    mutation PublicCertificateAnswerQuestionMutation($certificateId: ID!, $questionId: ID!, $answer: JSON!) {
        answerQuestion(certificateId: $certificateId, questionId: $questionId, answer: $answer) {
            _id
            quizStartedAt
            state
            numOfQuestionsAnswered
            currentQuestion
        }
    }
`
